module.exports = __webpack_public_path__ + "static/media/dc-nodata.d46f541b.svg";